(function ($) {
    function getUrlAddSvodFilm(videoProductionId) {
        return _urlSvodAddFilm.replace('-id-', videoProductionId)
    }

    function switchPlayButton(productId) {
        $('#btn-play-' + productId).hide();
        $('#btn-player-' + productId).show();
    }

    $(document).ready(function ($) {
        $('.btnAddMovie').on('click', function (e) {
            e.preventDefault()

            var productId = $(this).data('productid');
            var link = $(this).data('link');

            $.getJSON(getUrlAddSvodFilm(productId), {}, function (result) {
                if (result.message) {
                    if (UVII.localServerFound === false) {
                        // Local server is not found, show modal and prevent play
                        jQuery('.modal-content-checkout').hide()
                        jQuery('.overlay').hide();
                        jQuery('#splashDownloadModal1').modal();
                    } else {
                        UVII.launchDeeplink(link + result.userSvodProductId + getDeeplinkAuthParams());
                    }
                }
            })
        });

        $('.btnWatchSvod').click(function () {
            $('.svod-edito-modal').modal('hide');
        });

        $('.js-trigger-overlay-svod').click(function (e) {
            e.preventDefault();
            $('.overlay__container').css("display", "block");
        });

        $('.overlay-svod__close').click(function (e) {
            e.preventDefault();
            $('.overlay__container').css("display", "none");
        });

        $('.js-trigger-overlay-svod-keep').click(function (e) {
            e.preventDefault();
            $('.overlay__container_keep').css("display", "block");
        });

        $('.overlay-svod-keep__close').click(function (e) {
            e.preventDefault();
            $('.overlay__container_keep').css("display", "none");
        });

        const historyWrapper = document.querySelector('#list-user-films.history-wrapper');
        if (historyWrapper) {
            historyWrapper.addEventListener('click', e => {
                const { target } = e;
                if (target.matches('.js-delete-film-history')) {
                    e.preventDefault();
                    const url = target.getAttribute('data-url');
                    const id = target.getAttribute('data-id');
                    const filmIcon = $('li[data-id = ' + id + ']');
                    ajaxDeleteFilmHistory(url, filmIcon);
                }
            });
        }

        function ajaxDeleteFilmHistory(url, filmIcon) {
            $.ajax({
                url: url,
                method: 'DELETE',
                dataType: 'json',
                success: function (data) {
                    growl_message(data.message);
                    if (data.status == 'ok') {
                        filmIcon.remove();
                    }
                }
            });
        };

        function ajaxSwitchRenew(blocParent) {
            $.ajax({
                url: $(this).attr('href')
                , type: 'get'
                , dataType: 'json'
                , success: function (result) {
                    var classRenew = '';
                    if (result.data.isToRenew == "1") {
                        classRenew = 'isToRenew';
                    } else {
                        classRenew = 'isNotToRenew';
                    }
                    blocParent.removeClass().addClass(classRenew);
                }
            });
        };

        $('.linkSwitchSubscribe').on('click', function (e) {
            e.preventDefault();
            var blocParent = $(this).parent().parent();
            ajaxSwitchRenew(blocParent);
        });

        $('.watch-film-btn-edito').on('click', function (e) {
            var modalBackdrop, body;
            modalBackdrop = document.getElementsByClassName("modal-backdrop")[0];
            body = document.getElementsByTagName("body")[0];
            if (modalBackdrop) {
                body.removeChild(modalBackdrop);
            }
            var currentPath = $(this).data('currentpath');
            optionFilm('watch', currentPath).then(function (response) {
                new Modal(response).showModal();
                $('.btnAddMovie').on('click', function (e) {
                    e.preventDefault()

                    var productId = $(this).data('productid');
                    var link = $(this).data('link');

                    $.getJSON(getUrlAddSvodFilm(productId, link), {}, function (result) {
                        if (result.message) {
                            if (UVII.localServerFound === false) {
                                // Local server is not found, show modal and prevent play
                                jQuery('.modal-content-checkout').hide()
                                jQuery('.overlay').hide();
                                jQuery('#splashDownloadModal1').modal();
                            } else {
                                UVII.launchDeeplink(link + result.userSvodProductId + getDeeplinkAuthParams());
                            }
                        }
                    })
                });

            });
        });
        optionFilm = function (type, currentPath) {
            var currentRoute, port, request, requestUrl;
            currentRoute = window.location;
            port = currentRoute.port !== 80 ? ":" + currentRoute.port : "";
            requestUrl = currentRoute.protocol + "//" + currentRoute.hostname + port + currentRoute.pathname + "/product/" + type;
            if (currentPath) {
                requestUrl = currentPath + "/product/" + type;
            }
            request = new Request();
            request.prepare('GET', requestUrl, true);
            return request.sendRequest();
        };
        $('.transactions-wrapper').on('click', '.transaction-item-link', function (e) {
            e.preventDefault();
            var _self = this;
            var confMsg = $(this).data('confirm');
            if (confirm(confMsg)) {
                $.ajax($(this).data('url'),
                    {
                        method: 'DELETE',
                        dataType: 'json',
                        success: function (data, textStatus, transport) {
                            growl_message(data.message);
                            if (data.status == 'ok') {
                                $(_self).parents('.row-user-transactions').remove();
                            }
                        }
                    }
                );
            }
        });

        /*** Compte > Mon abonnement > Changer ***/

        let offerSelected = null;
        let changeButton = $('.mySpaceSvodSubscription .svodChange .change-offer-button');
        let extendButton = $('.mySpaceSvodSubscription .svodChange .extend-offer-button');
        let extendPossible = extendButton && extendButton.data('extend-possible') == true;
        //Clique sur offre
        $('.mySpaceSvodSubscription .svodChange .offer').click(function (e) {
            e.preventDefault();
            //Elements
            offerSelected = $(this);
            let actualOffer = $('.mySpaceSvodSubscription .svodChange .actual-offer');
            let isActualOffer = offerSelected.is(actualOffer);

            //Offre séléctionné
            $('.mySpaceSvodSubscription .svodChange .offer').removeClass('offer-selected');
            offerSelected.addClass('offer-selected');

            //Bouton de changement d'offre
            changeButton.css('display', isActualOffer ? 'none' : 'inline-block');

            //Prolongement de l'offre actuelle
            if (extendButton)
                extendButton.css('display', isActualOffer && extendPossible ? 'inline-block' : 'none');

            //Changement
            if (!isActualOffer) {
                //Information des modals
                $('.change-svod-modal .svod-product-summary').text(offerSelected.data('summary'));
                $('.change-svod-modal .changeInformationText').text(offerSelected.data('change-information'));
                $('.change-svod-modal .svod-keep-yes .accept-change-offer').attr('href', offerSelected.data('change-path'));

                $('#modal-change-inprogress .has-change-inprogress').text(offerSelected.data('has-change-inprogress'));
            }
        });

        //Bouton changement d'offre
        $('.mySpaceSvodSubscription #change-offer .change-offer-button').click(function (e) {
            e.preventDefault();
            if (offerSelected !== null) {
                let hasChangeInprogress = offerSelected.data('has-change-inprogress');
                if (typeof hasChangeInprogress === 'string' && hasChangeInprogress.length > 0) {
                    //Changement impossible car déjà en cours
                    $('#modal-change-inprogress').modal('show');
                } else {
                    //Changement d'offre
                    $('.change-svod-modal').css('display', 'block');
                }
            }
        });

        //Bouton d'annulation
        $('.change-svod-modal .svod-keep-no a.btn').click(function (e) {
            e.preventDefault();
            $('.change-svod-modal').css('display', 'none');
        });
    })
})(jQuery)
